/**
 * generateClassName generates a class name based on a @prefix and a @value
 * If the value is falsy, it returns an empty string
 * Otherwise, it returns a string composed of the prefix and the value (converted to lowercase), separated by a space
 */
const generateClassName = (prefix, value) => {
    if (!value) return "";

    const suffix = value === "None" ? "none" : value.toLowerCase();
    return ` ${prefix}${suffix}`;
};

/**
 * getSpacingClassName generates a spacing class name based on @additionalConfiguration
 * It takes an additional configuration object, a default class name, and a desktop breakpoint as input
 * If the additional configuration is falsy, it returns the default class name
 * Otherwise, it generates a class name for each type of spacing (padding and margin) for both mobile and desktop, and returns the combined class name
 */
const getSpacingClassName = (additionalConfiguration, defaultClassName = "", desktopBreakpoint = "lg") => {
    if (!additionalConfiguration) {
        return defaultClassName;
    }

    const { spacingTop, spacingBottom } = additionalConfiguration;
    const createSpacingClass = (type, size, device = null) =>
        generateClassName(`${device ? `${device}:` : ""}${type}-`, size);

    const sectionClassName = [
        createSpacingClass("pt", spacingTop?.paddingMobile),
        createSpacingClass("pt", spacingTop?.paddingDesktop, desktopBreakpoint),
        createSpacingClass("pb", spacingBottom?.paddingMobile),
        createSpacingClass("pb", spacingBottom?.paddingDesktop, desktopBreakpoint),
        createSpacingClass("mt", spacingTop?.marginMobile),
        createSpacingClass("mt", spacingTop?.marginDesktop, desktopBreakpoint),
        createSpacingClass("mb", spacingBottom?.marginMobile),
        createSpacingClass("mb", spacingBottom?.marginDesktop, desktopBreakpoint),
    ].join("");

    return sectionClassName;
};

export { getSpacingClassName };
